import { FormGroup, Input, Label, InputProps } from "reactstrap";

interface CustomInputProps extends InputProps {
  label?: string;
  placeholder?: string;
  style?: React.CSSProperties;
  min?:string,
  asterisk?:boolean
}

const removeEmojis = (text: string) =>
  text.replace(/[\p{Emoji_Presentation}\p{Extended_Pictographic}]/gu, "");

const CustomInput: React.FC<CustomInputProps> = ({
  label,
  placeholder,
  type = "text",
  style,
  onChange,
  min,
  asterisk = false,
  ...rest
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const cleanedValue = removeEmojis(e.target.value);

    const event = {
      ...e,
      target: {
        ...e.target,
        value: cleanedValue,
      },
    };

    // Trigger the original onChange prop with the cleaned value
    onChange?.(event as React.ChangeEvent<HTMLInputElement>);
  };

  return (
    <FormGroup style={{ width: "100%" }}>
      {" "}
      {/* Ensuring full width and no extra margin */}
      {label && (
        <Label
          style={{
            fontWeight: "500",
            // color: "#000",
            marginBottom: "6px",
            display: "block",
            marginTop: "10px",
          }}
        >
          {label}{asterisk &&(<span style={{color:"red"}}>*</span>)}
        </Label>
      )}
      <Input
        min={min}
        type={type}
        placeholder={placeholder}
        onChange={handleChange}
        {...rest}
        style={{
          width: "100%",
          borderRadius: "8px",
          backgroundColor: "transparent",
          // External Css
          ...style,
        }}
      />
    </FormGroup>
  );
};

export default CustomInput;
